<!-- 图片编辑 -->
<template>
  <div class="cropper-content">
    <div class="cropper-box">
      <div class="cropper">
        <video v-if="showVideoPath" :src="showVideoPath" class="avatar video-avatar" controls="controls" style="width:100%; height: 300px" autoplay="autoplay"></video>
      </div>
      <!--底部操作工具按钮-->
      <div class="footer-btn">
        <div class="scope-btn">
          <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" v-bind:before-upload="beforeUploadVideo" :http-request="handleHttpRequestVideo" v-bind:show-file-list="false">
            <i class="el-icon-plus avatar-uploader-icon btn">选择视频</i>
          </el-upload>
        </div>
        <div class="upload-btn" :style="{justifyContent:'left'}">
          <el-button size="mini" v-loading.fullscreen.lock="fullscreenLoading" type="success" @click="uploadVideo('blob')">上传视频 <i class="el-icon-upload"></i></el-button>
          <el-button size="mini" @click="closeVideo">取消 <i class="el-icon-circle-close"></i></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CropperVideo",
    data() {
      return {
        showVideoPath:"",// 视频地址
        videoFile:"",// 视频地址
        fullscreenLoading: false // 视频加载
      };
    },
    methods: {
      //上传前回调
      beforeUploadVideo(file) {
        let fileSize = file.size / 1024 / 1024 < 50;   //控制大小  修改50的值即可
        if (
          ["video/mp4"].indexOf(file.type) == -1     //控制格式
        ) {
          this.$message.error("请上传正确的视频格式");
          return false;
        }
        if (!fileSize) {
          this.$message.error("视频大小不能超过50MB");
          return false;
        }
      },
      // 上传获取地址
      handleHttpRequestVideo(data){
        let url = window.webkitURL.createObjectURL(data.file) ;
        this.showVideoPath = url;
        this.videoFile = data.file;
      },
      //上传视频
      async uploadVideo () {
        if (this.videoFile == ""){
          this.$message({
            message: '请先选择视频在上传！',
            type: "error"
          });
          return;
        }
        this.fullscreenLoading = true;
        let video = '';
        let formData = new FormData();
        formData.append('file',this.videoFile,'DX.mp4')
        //调用axios上传
        await this.$api.fileUpload(formData).then(res => {
          if (res.data.status == 200) {
            video = res.data.data;
            this.$emit('uploadVideoSuccess',video);
            this.showVideoPath = "";
            this.videoFile = "";
            this.fullscreenLoading = false;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 关闭弹出框
      closeVideo(){
        this.$emit('handleVideoClose');
      },
      // 关闭弹出框
      beClose(){
        this.showVideoPath = "";
        this.videoFile = "";
      },
    },
  }
</script>

<style scoped>
  .cropper-content {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
  }

  .cropper-content .cropper-box {
    flex: 1;
    width: 100%;
  }

  .cropper-content .cropper-box .cropper {
    width: auto;
    height: 300px;
  }

  .cropper-content .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
  }

  .cropper-content .show-preview .preview {
    overflow: hidden;
    border: 1px solid #67c23a;
    background: #cccccc;
  }

  .footer-btn {
    margin-top: 30px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
  }

  .footer-btn .scope-btn {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding-right: 10px;
  }

  .footer-btn .upload-btn {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: right;
  }

  .footer-btn .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    margin-right: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Dialog/CropperVideo.vue